<template>
  <main class="map-page">
    <!-- Menú lateral -->
    <NavDrawer />

    <!-- Mapa principal -->
    <MapView ref="mapView" :style="mapViewportStyle" />

    <!-- Herramientas flotantes; Consulta permanece siempre montada dentro del contenedor -->
    <ToolContainer />
    <!-- Contenedores de datos dinámicos -->
    <DataContainer />

    <!-- Controles custom del mapa -->
    <MapControlsCustom />

    <!-- Aviso de capas que aún están cargando su imagen (QA-106) -->
    <LayerLoadingNotice />

    <!-- Toast Notification System -->
    <ToastNotification />
  </main>
</template>

<script>
// Servicios del mapa
import { mapService } from '@/services/map/mapService'
import { mapControlsService } from '@/services/map/mapControlsService'

// Componentes
import MapView from '@/components/MapView.vue'
import MapControlsCustom from '@/components/mapControls/MapControlsCustom.vue'
import NavDrawer from '@/components/mapControls/NavDrawer.vue'
import ToolContainer from '@/components/mapTools/ToolContainer.vue'
import DataContainer from '@/components/mapTools/DataContainer.vue'
import ToastNotification from '@/components/common/ToastNotification.vue'
import LayerLoadingNotice from '@/components/mapTools/layers/LayerLoadingNotice.vue'

// Mixins
import {restMapActivity} from '@/components/mixin/restMapActivity.js'


export default {
  name: 'MapContainer',
  mixins: [restMapActivity],
  components: {
    MapView,
    MapControlsCustom,
    NavDrawer,
    ToolContainer,
    DataContainer,
    ToastNotification,
    LayerLoadingNotice,
  },

  data() {
    return {
      overviewMapControl: null
    }
  },

  computed: {
    attributeTableHeight() {
      return this.$store.getters["attributeTable/layoutHeight"] || 0;
    },
    mapViewportStyle() {
      return {
        height: `calc(100% - ${this.attributeTableHeight}px)`
      };
    }
  },

  watch: {
    attributeTableHeight() {
      this.$nextTick(() => {
        window.requestAnimationFrame(() => {
          const map = mapService.get();
          if (map) map.updateSize();
        });
      });
    }
  },

  mounted() {
    const map = mapService.get();
    if (map) {
      const controls = mapControlsService.addDefaultControls(map, {
        onOverviewActivate: this.openBasemapPanel
      });
      this.overviewMapControl = controls.overview;
      this.recordMapVisit(this.$route.params.idMap)
    }
    window.addEventListener('beforeunload', this._onBeforeUnload)
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload', this._onBeforeUnload)
    if (this.overviewMapControl && this.overviewMapControl.removeActivationListeners) {
      this.overviewMapControl.removeActivationListeners()
    }
    this.overviewMapControl = null
    this._closeAllLayerSessions()
    // activeLayers es estado global de la sesión SPA: sin esta limpieza, al
    // reentrar a un mapa el checkbox de la categoría aparecía marcado
    // (categoryCheckState cuenta contra getActiveLayers) con todas las capas
    // desmarcadas y nada dibujado. Va después de _closeAllLayerSessions(),
    // que todavía lee _sessionId desde las capas activas.
    this.$store.dispatch('cleanActiveLayers')
    mapService.destroy();
  },

  methods: {
    openBasemapPanel() {
      this.$store.dispatch('setMapToolSelection', {
        tool: 'basemap',
        active: true
      })
    },

    _closeAllLayerSessions() {
      const backendurl = this.$store.getters.backendurl

      // Sesiones de capas externas WMS (wmsSessionIds en store)
      const wmsIds = this.$store.state.wmsSessionIds || {}
      Object.entries(wmsIds).forEach(([layerId, sessionId]) => {
        this.$store.commit('clearWmsSessionId', layerId)
        this.$http.patch(`${backendurl}api/v1/layer-activity/${sessionId}/end`).catch(() => {})
      })

      // Sesiones de capas normales (_sessionId en cada capa activa)
      const activeLayers = this.$store.getters.getActiveLayers || []
      activeLayers.forEach(layer => {
        if (layer._sessionId) {
          const sessionId = layer._sessionId
          layer._sessionId = null
          this.$http.patch(`${backendurl}api/v1/layer-activity/${sessionId}/end`).catch(() => {})
        }
      })
    },

    _onBeforeUnload() {
      const backendurl = this.$store.getters.backendurl
      const opts = { method: 'PATCH', keepalive: true, credentials: 'include' }

      const wmsIds = this.$store.state.wmsSessionIds || {}
      Object.values(wmsIds).forEach(sessionId => {
        fetch(`${backendurl}api/v1/layer-activity/${sessionId}/end`, opts).catch(() => {})
      })

      const activeLayers = this.$store.getters.getActiveLayers || []
      activeLayers.forEach(layer => {
        if (layer._sessionId) {
          fetch(`${backendurl}api/v1/layer-activity/${layer._sessionId}/end`, opts).catch(() => {})
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.map-page {
  position: fixed;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100vh;
  background: rgb(0, 111, 179);
  overflow: hidden;
  z-index: 1000;
}
</style>
